import React from 'react';
import { Container, Content, Logo, LogoContainer, Heading, Tagline, CompanyName, ComingSoon } from './Hero.styles';

const Hero = () => (
  <Container>
    <Content>
    <LogoContainer>
        <Logo viewBox="0 0 100 100">
        <path d="M50 0 L100 50 L50 100 L0 50 Z" fill="#64ffda" />
        </Logo>
        <CompanyName>Ocklet</CompanyName>
    </LogoContainer>
    <Heading>Next-Gen IT Solutions</Heading>
    <Tagline>Empowering businesses through strategic technology innovation</Tagline>
    <ComingSoon>Coming Soon</ComingSoon>
    </Content>
  </Container>
);

export default Hero;